'use strict';

/**
 * @ngdoc overview
 * @name gfcmsApp
 * @description
 * # gfcmsApp
 *
 * Routes for the application.
 */
angular
  .module('gfcmsApp')
  .config(function ($routeProvider, $locationProvider) {

    $routeProvider
      .when('/', {
        templateUrl: 'views/main.html',
        controller: 'MainCtrl',
        controllerAs: 'mainVm'
      })
      .when('/about', {
        templateUrl: 'views/about.html',
        controller: 'AboutCtrl',
        controllerAs: 'about'
      })
      .when('/login', {
        templateUrl: 'views/login2.html',
        controller: 'LoginCtrl',
        controllerAs: 'loginVm'
      })
      .when('/register', {
        templateUrl: 'views/register.html',
        controller: 'RegisterCtrl'
      })
      .when('/customers', {
        templateUrl: 'views/customers.html',
        controller: 'CustomersCtrl',
        controllerAs: 'customersVm',
        permission: 'customers.read'
      })
      .when('/customers/left', {
        template: `<gf-missed-customers-list></gf-missed-customers-list>`,
        permission: 'users.manage'
      })
      .when('/customers/:customerId', {
        templateUrl: 'views/customer.details.html',
        controller: 'CustomerDetailsCtrl',
        controllerAs: 'customerVm',
        permission: 'customers.read'
      })
      .when('/customers/:customerId/orders', {
        templateUrl: 'views/customer.orders.html',
        controller: 'CustomerOrdersCtrl',
        controllerAs: 'customerOrdersVm',
        permission: 'customers.update'
      })
      .when('/newcustomer', {
        templateUrl: 'views/newcustomer.html',
        controller: 'NewcustomerCtrl',
        controllerAs: 'vm',
        permission: 'customers.create'
      })
      .when('/customers/:customerId/update', {
        templateUrl: 'views/newcustomer.html',
        controller: 'NewcustomerCtrl',
        controllerAs: 'vm',
        permission: 'customers.update'
      })
      .when('/profile', {
        templateUrl: 'views/profile.details.html',
        controller: 'ProfileDetailsCtrl',
        controllerAs: 'profileDetailsVm'
      })
      .when('/browse', {
        templateUrl: 'views/browse.html',
        controller: 'BrowseCtrl',
        controllerAs: 'browse'
      })
      .when('/404', {
        templateUrl: '404.html',
        controller: 'NotFoundCtrl',
        controllerAs: 'browse'
      })
      .when('/users', {
        templateUrl: 'views/users.html',
        controller: 'UsersCtrl',
        controllerAs: 'usersVm',
        permission: 'users.read'
      })
      .when('/users/:userId', {
        templateUrl: 'views/user.details.html',
        controller: 'UserDetailsCtrl',
        controllerAs: 'userVm',
        permission: 'users.read'
      })
      .when('/newuser', {
        templateUrl: 'views/newuser.html',
        controller: 'NewuserCtrl',
        controllerAs: 'newUserVm',
        permission: 'users.create'
      })
      .when('/users/edit/:userId', {
        templateUrl: 'views/newuser.html',
        controller: 'NewuserCtrl',
        controllerAs: 'newUserVm',
        permission: 'users.update'
      })
      .when('/users/:userId/changepassword', {
        templateUrl: 'views/changepassword.html',
        controller: 'UserChangepasswordCtrl',
        controllerAs: 'changePasswordVm',
        permission: 'users.manage'
      })
      .when('/schedules', {
        templateUrl: 'views/schedules.html',
        controller: 'SchedulesCtrl',
        controllerAs: 'schedulesVm',
        permission: 'schedules.read'
      })
      .when('/myschedules', {
        templateUrl: 'views/schedules.html',
        controller: 'SchedulesCtrl',
        controllerAs: 'schedulesVm',
        action: 'personalise'
      })
      .when('/myschedules/:scheduleId', {
        templateUrl: 'views/schedule.html',
        controller: 'ScheduleDetailsCtrl',
        controllerAs: 'scheduleVm',
        resolve: {
          schedulePrepService: schedulePrepService
        },
        action: 'personalise'
      })
      .when('/schedules/:scheduleId', {
        templateUrl: 'views/schedule.html',
        controller: 'ScheduleDetailsCtrl',
        controllerAs: 'scheduleVm',
        resolve: {
          schedulePrepService: schedulePrepService
        },
        permission: 'schedules.read'
      })
      .when('/newschedule', {
        templateUrl: 'views/newschedule.html',
        controller: 'NewscheduleCtrl',
        controllerAs: 'newScheduleVm',
        permission: 'schedules.create'
      })
      .when('/orders/new/:homeId', {
        templateUrl: 'views/neworder.html',
        controller: 'NeworderCtrl',
        controllerAs: 'newOrderVm',
        permission: 'orders.read'
      })
      .when('/orders/edit/:orderId', {
        templateUrl: 'views/neworder.html',
        controller: 'NeworderCtrl',
        controllerAs: 'newOrderVm',
        permission: 'orders.update'
      })
      .when('/homes/new/:customerId', {
        templateUrl: 'views/newhome.html',
        controller: 'NewhomeCtrl',
        controllerAs: 'newHomeVm',
        permission: 'homes.create'
      })
      .when('/homes/edit/:homeId', {
        templateUrl: 'views/newhome.html',
        controller: 'NewhomeCtrl',
        controllerAs: 'newHomeVm',
        permission: 'homes.update'
      })
      .when('/schedules/:scheduleId/jobs', {
        templateUrl: 'views/schedule.jobs.html',
        controller: 'ScheduleJobsCtrl',
        controllerAs: 'scheduleJobsVm',
        permission: 'schedules.update',
        resolve: {
          scheduleJobsPrepService: scheduleJobsPrepService
        }
      })
      .when('/jobs/:jobId/complete', {
        templateUrl: 'views/job.complete.html',
        controller: 'JobCompleteCtrl',
        controllerAs: 'completeJobsVm',
        resolve: {
          /**
           * @param $route
           * @param {JobService} jobService
           * @return JobUpdateInfo
           */
          /* ngInject */
          jobUpdateInfo: function ($route, jobService, cfpLoadingBar) {
            cfpLoadingBar.start();
            return jobService.getUpdateInfo($route.current.params.jobId)
              .then(function (response) {
                cfpLoadingBar.complete();
                return response;
              });
          }
        },
        permission: ['schedule.user', 'jobs.update']
      })
      .when('/settings/acl', {
        templateUrl: 'views/settings.html',
        controller: 'SettingsCtrl',
        controllerAs: 'settingsVm',
        permission: 'users.manage'
      })
      .otherwise({
        redirectTo: '/404'
      });

    $locationProvider.html5Mode(true);

    /* @ngInject */
    function schedulePrepService($q, $route, scheduleService, cfpLoadingBar, FlashService) {
      cfpLoadingBar.start();
      var id = $route.current.params.scheduleId;
      var promises = [
        scheduleService.GetById(id),
        scheduleService.getJobs(id)
      ];

      return $q.all(promises)
        .then(function (results) {
          return {
            schedule: results[0],
            jobs: results[1]
          };
        })
        .catch(function () {
          FlashService.Error('Network Error. Try reloading the page');
        })
        .finally(function () {
          cfpLoadingBar.complete();
        });
    }

    /* ngInject */
    function scheduleJobsPrepService($q, $route, scheduleService, FlashService) {
      var scheduleId = $route.current.params.scheduleId;
      var promises = [
        scheduleService.GetById(scheduleId),
        scheduleService.getJobs(scheduleId),
        scheduleService.getMaintenanceCustomers(scheduleId)
      ];

      /**
       * @property {function(): Promise<{schedule: any, jobs: Job[], maintenanceCustomers: any[]}>} get
       */
      return $q.all(promises)
        .then(function (results) {
          return {
            schedule: results[0],
            jobs: results[1],
            maintenanceCustomers: results[2]
          };
        })
        .catch(function () {
          FlashService.Error('Network Error. Try reloading the page');
        });
    }
  });
